import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import { defineMessages } from '@atlassian/jira-intl';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import imageUrl from './empty.svg';

const messages = defineMessages({
	header: {
		id: 'project-components.filter-no-results-nothing-matched-your-search',
		defaultMessage: "We didn't find any components that matched your search",
		description: '',
	},
	emptyStateMessageDescription: {
		id: 'project-components.filter-no-results-nothing-matched-your-search-description',
		defaultMessage: 'Try using specific component names or terms.',
		description: 'Components table empty state no components found default message description',
	},
});

type Props = {
	intl: IntlShape;
};

function EmptyView(props: Props) {
	const {
		intl: { formatMessage },
	} = props;
	return (
		<EmptyState
			imageUrl={imageUrl}
			header={formatMessage(messages.header)}
			description={formatMessage(messages.emptyStateMessageDescription)}
			headingLevel={2}
			size="narrow"
		/>
	);
}

export default injectIntl(EmptyView);
